<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>search</md-icon>
          </div>
          <h4 class="title">LINEミニアプリ売上レポート</h4>
        </md-card-header>

        <md-card-content class="md-layout formLayout">

          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              集計期間
            </label>
            <div class="md-layout-item md-size-20 md-xsmall-size-100" style="position:relative">
              <vuejs-datepicker
                :format="DatePickerFormat"
                v-model="orderedFrom"
                :language="ja"></vuejs-datepicker>
              <md-button
                class="md-just-icon md-default md-simple dateDelete"
                @click.native="orderedFrom = ''">
                <md-icon>close</md-icon>
              </md-button>
            </div>
            <div class="md-layout-item md-size-5 betweenTime is-xs-none"> 〜 </div>
            <div class="md-layout-item md-size-20 md-xsmall-size-100" style="position:relative">
              <vuejs-datepicker
                :format="DatePickerFormat"
                v-model="orderedTo"
                :language="ja"></vuejs-datepicker>
              <md-button
                class="md-just-icon md-default md-simple dateDelete"
                @click.native="orderedTo = ''">
                <md-icon>close</md-icon>
              </md-button>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              集計タイプ
            </label>
            <div class="md-layout-item md-xsmall-size-100">
              <md-field class="aggregateType">
                <md-select v-model="aggregateType" name="aggregateType">
                  <md-option value="company">企業別</md-option>
                  <md-option value="brand">ブランド別</md-option>
                  <md-option value="store">店舗別</md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
          </div>

          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              事業者
            </label>
            <div class="md-layout-item md-xsmall-size-100">
              <company-select v-model="companyId" :noSelectFlag="true"></company-select>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100" v-show="aggregateType !== 'company'">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              ブランド
            </label>
            <div class="md-layout-item md-xsmall-size-100">
              <brand-select ref="brand" v-model="brandId" :noSelectFlag="true"></brand-select>
            </div>
          </div>

          <div class="md-layout md-layout-item md-size-50 md-xsmall-size-100" v-show="aggregateType === 'store'">
            <label class="md-layout-item md-size-30 md-form-label md-xsmall-size-100">
              店舗名
            </label>
            <div class="md-layout-item md-xsmall-size-100">
              <shop-select ref="shop" v-model="shopId" :noSelectFlag="true"></shop-select>
            </div>
          </div>

        </md-card-content>
        <md-card-actions md-alignment="left" class="mt60 mx-auto">
          <md-button class="md-warning md-lg" @click="handleCsvExport()">エクスポート</md-button>
        </md-card-actions>
      </md-card>
    </div>
    <transition name="fade">
      <div class="md-layout-item md-size-100" v-if="resultFlag">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <h4 class="title">検索結果</h4>
          </md-card-header>
          <md-card-content>
            <div class="dataTableWrapper">
              <div class="dataTable">
                <div class="tHead">
                  <div class="tHead_th">CSV名</div>
                  <div class="tHead_th">集計期間</div>
                  <div class="tHead_th">集計タイプ</div>
                  <div class="tHead_th">作成日時</div>
                  <div class="tHead_th taR">ダウンロード</div>
                </div>
                <div v-for="item in tableData" :data-id="item.id" class="tItem" :key="item.id">
                  <div class="tItem_td">{{ item.fileName }}</div>
                  <div class="tItem_td">{{ item.period }}</div>
                  <div class="tItem_td">{{ item.aggregateTypeName }}</div>
                  <div class="tItem_td">{{ item.createdAt }}</div>
                  <div class="tItem_td taR td_actionTw">
                    <md-button
                      class="md-just-icon md-warning mg2"
                      @click.native="handleDownload(item)">
                      <md-icon>download</md-icon>
                    </md-button>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">全{{ pageData.totalCount | numberWithDelimiter }}件中 {{from | numberWithDelimiter}}件から {{to | numberWithDelimiter}}件を表示</p>
            </div>
            <Pagination class="Pagination-no-border Pagination-success"
              :currentPage="pageData.currentPage"
              :totalPage="pageData.totalPage"
              @get="getCsvList">
            </Pagination>
          </md-card-actions>
        </md-card>
      </div>
    </transition>
  </div>

</template>

<script>
  import Pagination from '../components/additional/Pagination.vue'
  import CompanySelect from '../components/additional/CompanySelect.vue'
  import BrandSelect from '../components/additional/BrandSelect.vue'
  import ShopSelect from '../components/additional/ShopSelect.vue'
  import router from '../packs/router.js'
  import role from "../mixins/role.js"
  import swal from 'sweetalert2'

  export default {
    mixins: [ role ],
    components: {
      CompanySelect,
      BrandSelect,
      ShopSelect,
      Pagination
    },
    computed: {
      to () {
        return (this.pageData.currentPage - 1) * 25 + this.tableData.length
      },
      from () {
        return (this.pageData.currentPage - 1) * 25 + 1
      }
    },
    data () {
      return {
        orderedFrom: '',
        orderedTo: '',
        aggregateType: 'company',
        companyId: '選択しない',
        brandId: '選択しない',
        shopId: '選択しない',
        tableData: [],
        resultFlag: false,
        pageData: {
          totalPage: 0,
          currentPage: 0,
          nextPage: null,
          prevPage: null,
          totalCount: 0
        }
      }
    },
    methods: {
      handleCsvExport () {
        if (this.orderedFrom === '' || this.orderedTo === '') {
          this.dangerNotify('集計期間を指定してください')
          return
        }
        swal({
          title: 'CSVエクスポート処理を開始します。',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-success btn-fill',
          cancelButtonClass: 'md-button md-danger btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false
        }).then((result) => {
          if(result.value){
            this.getCsvExport()
          }
        });
      },
      getCsvExport () {
        var condition = {
          aggregate_type: this.aggregateType,
          ordered_from: this.initDate(this.orderedFrom),
          ordered_to: this.initDate(this.orderedTo),
          company_id: this.companyId === '選択しない' ? '' : this.companyId,
          brand_id: (this.aggregateType === 'company' || this.brandId === '選択しない') ? '' : this.brandId,
          shop_id: (this.aggregateType !== 'store' || this.shopId === '選択しない') ? '' : this.shopId
        }
        this.successAndBackPage("CSVのアップロードを開始しました。完了後メールでお知らせします。")
        this.axios({
          method  : 'POST',
          url     : this.AdminApiUrl + '/purchase_archives/export_csv',
          timeout : 30000,
          data: condition,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else if (error.response.data.error === "PurchaseArchive not found")  {
            this.noSearchResults()
          } else {
            this.dangerNotify('CSVエクスポートに失敗しました')
          }
        })
      },
      getCsvList (page) {
        var condition = {
          page: !isNaN(page) ? page : 1,
          class_name: 'PurchaseArchive'
        }
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/export_logs/',
          timeout : 30000,
          headers : {'Authorization': this.$Cookies.get('accessToken')},
          params: condition
        }).then(response => {
          if (response.data.data.length === 0) {
            this.resultFlag = false
          } else {
            this.createList(response.data)
            this.pageData.totalPage = response.data.meta['total-pages']
            this.pageData.currentPage = response.data.meta['current-page']
            this.pageData.totalCount = response.data.meta['total-count']
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('CSVデータを正しく取得できませんでした')
          }
        })
      },
      createList (obj) {
        var res = obj.data
        this.tableData.splice(0)
        for (var i in res) {
          var parsed = this.parseFileName(res[i].attributes['file-name'])
          var item = {
            id: res[i].id,
            fileName: res[i].attributes['file-name'],
            period: parsed.period,
            aggregateTypeName: parsed.aggregateTypeName,
            createdAt: res[i].attributes['created-at']
          }
          this.tableData.push(item)
        }
        this.resultFlag = true
      },
      // file_name（line_mini_app_sales_by_{type}_{from}_{to}）から集計期間・集計タイプを導出する。
      // パース不能な行（深夜バッチ分 purchase_archives）は「定期バックアップ」と表示する。
      parseFileName (fileName) {
        var matched = (fileName || '').match(/line_mini_app_sales_by_(company|brand|store)_(\d{8})_(\d{8})/)
        if (matched === null) {
          return {
            period: '—',
            aggregateTypeName: '定期バックアップ'
          }
        }
        var typeNames = {
          company: '企業別',
          brand: 'ブランド別',
          store: '店舗別'
        }
        return {
          period: this.formatYmd(matched[2]) + ' 〜 ' + this.formatYmd(matched[3]),
          aggregateTypeName: typeNames[matched[1]]
        }
      },
      formatYmd (ymd) {
        return ymd.slice(0, 4) + '/' + ymd.slice(4, 6) + '/' + ymd.slice(6, 8)
      },
      handleDownload (item) {
        var condition = {
          file_name: item.fileName
        }
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/export_logs/' + item.id + '/download',
          timeout : 30000,
          responseType: 'arraybuffer',
          headers : {'Authorization': this.$Cookies.get('accessToken'), 'Accept': 'application/zip'},
          params: condition
        }).then(response => {
          var blob = new Blob([response.data], { "type" : "application/x-zip-compressed" })
          var uri = URL.createObjectURL(blob)
          var link = document.createElement('a')
          link.download = response.config.params.file_name
          link.href = uri
          link.click()
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('CSVデータのダウンロードに失敗しました')
          }
        })
      }
    },
    mounted () {
      // role check
      if (!this.superFlag) {
        router.push({ path: '/admin/login'})
        return false
      }
      // 売上レポート停止中（Issue #126）は URL 直打ちでも画面を出さない（API 側も 403 を返す）
      if (!this.opt_lineMiniAppSalesReport) {
        router.push({ path: '/admin/top'})
        return false
      }
      this.getCsvList(1)
    },
    destroyed() {
      sessionStorage.removeItem('brandSelect')
      sessionStorage.removeItem('shopSelect')
    },
    watch: {
      companyId () {
        this.$refs.brand.companyId = this.companyId
        this.$refs.brand.resetBrand()
        this.$refs.shop.companyId = this.companyId
        this.$refs.shop.resetShop()
      },
      brandId () {
        this.$refs.shop.brandId = this.brandId
        this.$refs.shop.resetShop()
      },
      aggregateType () {
        if (this.aggregateType === 'company') {
          this.brandId = '選択しない'
        }
        if (this.aggregateType !== 'store') {
          this.shopId = '選択しない'
        }
      }
    }
  }
</script>

<style lang="css" scoped>
.fade-enter-active, .fade-leave-active {
  will-change: opacity;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

.md-card .md-card-actions{
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.btnCenter{
  margin-left: auto !important;
  margin-right: auto !important;
}

.formLayout{
  flex-basis: auto;
}

.mg2{
  margin: 0 2px;
}

.dateDelete{
  position: absolute;
  top: 0;
  right: 0;
}

.betweenTime{
  line-height: 59px;
}

.md-card{
  z-index: inherit;
}

@media screen and (max-width:600px) {
  .md-card .md-card-content .md-form-label{
    text-align: left;
  }

  .is-xs-none{
    display: none;
  }

  .is-xs-block{
    display: block;
  }
}
</style>
